<template>
    <!-- 选择支付方式 -->
    <van-popup v-model="payVisible" position="bottom" round closeable>
        <div class="doctor-introduce-title">请选择支付方式</div>
        <div class="pay_popup_main">
            <van-radio-group v-model="payType">
                <div>
                    <van-cell title="微信支付" clickable @click="payType = 0" title-class="pay_popup_radio_label">
                        <template #icon>
                            <img class="pay_popup_icon" src="@/assets/pay_icon_wx.png" alt="">
                        </template>
                        <template #right-icon>
                            <van-radio :name="0" checked-color="#00BCD1"/>
                        </template>
                    </van-cell>
                </div>
                <div>
                    <van-cell title="好友代付" clickable @click="payType = 1" title-class="pay_popup_radio_label">
                        <template #icon>
                            <img class="pay_popup_icon" src="@/assets/pay_icon_hy.png" alt="">
                        </template>
                        <template #right-icon>
                            <van-radio :name="1" checked-color="#00BCD1" />
                        </template>
                    </van-cell>
                </div>
            </van-radio-group>
            <div class="pay_popup_action">
                <van-button
                    class="pay_popup_action_confirm"
                    color="#00BCD1"
                    block
                    @click="clickConfirmPay"
                >确认付款</van-button>
            </div>
        </div>
    </van-popup>
</template>

<script>
export default {
    name: "ChoosePayType",
    data: () => ({
        payType: 0
    }),
    props: {
        value: {
            type: Boolean,
            default: false
        },
        orderId: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        }
    },
    computed: {
        payVisible: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        clickConfirmPay () {
            this.$emit('input', false)
            if (this.payType == 1) {
                this.$router.push({
                    path: `/pay/invite-paid/${ this.orderId }`,
                    query: {
                        type: this.type
                    }
                })
            } else {
                this.$emit('confirm')
            }
        }
    }
}
</script>

<style scoped>
.doctor-introduce-title {
    font-size: 4.8vw;
    color: #12141a;
    text-align: center;
    font-weight: bold;
    padding: 5.3vw;
}

.pay_popup_main .pay_popup_radio_label{
    font-size: 3.73vw;
    font-weight: 500;
    color: #000;
    line-height: 8vw;
    padding-left: 2.4vw;
}
.pay_popup_main .pay_popup_icon {
    width: 8vw;
    height: 8vw;
    vertical-align: middle;
}
.pay_popup_main .pay_popup_action {
    padding: 14.53vw 4.27vw 12.8vw;
}
.pay_popup_main .pay_popup_action .pay_popup_action_confirm {
    border-radius: 1.6vw;
}
</style>



// WEBPACK FOOTER //
// src/components/ChoosePayType.vue